export default {
  login: 'https://oes.instructure.com',
  support:
    'mailto:support.analytics.services@oes.edu.au?subject=eLA Engagement Tool Issue&body=If it is technical please describe what platform and browser you are using.'
};
